export default __webpack_public_path__ + "static/media/contact-min.7529f41c.png";